import { render, staticRenderFns } from "./LandingContactPage.vue?vue&type=template&id=1ab4bbdf&scoped=true"
import script from "./LandingContactPage.vue?vue&type=script&lang=js"
export * from "./LandingContactPage.vue?vue&type=script&lang=js"
import style0 from "./LandingContactPage.vue?vue&type=style&index=0&id=1ab4bbdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab4bbdf",
  null
  
)

export default component.exports